/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Konsultan_NavInputs */

const en_mk_sol_konsultan_nav = /** @type {(inputs: Mk_Sol_Konsultan_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consultancies & research firms`)
};

const id_mk_sol_konsultan_nav = /** @type {(inputs: Mk_Sol_Konsultan_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konsultan & lembaga riset`)
};

/**
* | output |
* | --- |
* | "Consultancies & research firms" |
*
* @param {Mk_Sol_Konsultan_NavInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_konsultan_nav = /** @type {((inputs?: Mk_Sol_Konsultan_NavInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Konsultan_NavInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_konsultan_nav(inputs)
	return en_mk_sol_konsultan_nav(inputs)
});